<template>
  <div id="root">
    <vx-card title="Bereits versandt">
      <vs-table
        v-if="isMounted"
        ref="table"
        stripe
        description
        description-title="Angezeigt"
        description-connector="von"
        description-body="Einträgen"
        pagination
        :max-items="itemsPerPage"
        search
        noDataText="Keine Einträge vorhanden"
        :data="paidAndSentOrders"
      >
        <template slot="thead">
          <vs-th sort-key="_id">ID</vs-th>
          <vs-th>Kunde</vs-th>
          <vs-th sort-key="createdAt">Zeit</vs-th>
          <vs-th sort-key="totalPrice">Preis</vs-th>
          <vs-th sort-key="paymentMethod">Zahlung</vs-th>
          <vs-th>Aktionen</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p class="text-xs text-grey truncate" style="max-width: 80px">
                  {{ tr._id.slice(-6) }}
                </p>
              </vs-td>

              <vs-td>
                <p class="font-semibold">
                  {{ (tr.shippingAddress && tr.shippingAddress.name) || "–" }}
                </p>
                <p class="text-xs text-grey">
                  {{ (tr.shippingAddress && tr.shippingAddress.phone) || "" }}
                </p>
              </vs-td>

              <vs-td>
                <p>{{ tr.createdAt | moment("DD.MM.YYYY HH:mm") }}</p>
                <p class="text-xs text-grey">
                  {{ tr.createdAt | moment("from") }}
                </p>
              </vs-td>

              <vs-td>
                <p class="font-semibold">{{ tr.totalPrice.toFixed(2) }} €</p>
              </vs-td>

              <vs-td>
                <div class="flex items-center">
                  <img
                    v-if="
                      tr.paymentMethod && tr.paymentMethod.includes('paypal')
                    "
                    src="/paypal-icon.svg"
                    style="width: 28px; height: 28px"
                  />
                  <img
                    v-else-if="
                      tr.paymentMethod && tr.paymentMethod.includes('bar')
                    "
                    src="/cash-icon.svg"
                    style="width: 24px; height: 24px"
                  />
                  <span v-else>{{ paymentLabel(tr.paymentMethod) }}</span>
                  <img
                    v-if="tr.paymentMethod && tr.paymentMethod.includes('app')"
                    src="/phone-icon.svg"
                    style="width: 28px; height: 28px; margin-left: 6px"
                  />
                </div>
              </vs-td>

              <vs-td>
                <div class="flex items-center">
                  <vs-button
                    size="small"
                    color="primary"
                    type="filled"
                    class="mr-2"
                    icon-pack="feather"
                    icon="icon-info"
                    @click="showDetails(tr)"
                    >Details</vs-button
                  >
                  <vs-button
                    size="small"
                    class="btn-print"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-printer"
                    @click="print(tr)"
                    >Drucken</vs-button
                  >
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vx-card>

    <!-- POPUP TO SHOW DETAILED DATA-->
    <vs-popup
      fullscreen
      v-if="selectedItem"
      class="holamundo"
      title="Details zur Lieferung"
      :active.sync="popupActive"
    >
      <div id="popup">
        <p class="font-bold">Adresse:</p>
        <p>{{ selectedItem.shippingAddress.name }}</p>
        <p>
          {{ selectedItem.shippingAddress.street }}
          <span>{{ selectedItem.shippingAddress.streetNumber }}</span>
        </p>
        <p>
          {{ selectedItem.shippingAddress.zipCode }}
          {{ selectedItem.shippingAddress.city }}
        </p>
        <p class="font-bold mt-4">Telefon:</p>
        <p>{{ selectedItem.shippingAddress.phone }}</p>
        <p
          v-if="selectedItem.shippingAddress.deliveryInstructions"
          class="font-bold mt-4"
        >
          Hinweise vom Kunden:
        </p>
        <p>{{ selectedItem.shippingAddress.deliveryInstructions }}</p>
        <p class="font-bold mt-4">Bestellung:</p>
        <br />
        <div
          class="ml-4"
          v-for="(order, index) in selectedItem.orderItems"
          :key="index"
        >
          <p class="font-bold">{{ order.name }}</p>
          <p>Anzahl: {{ order.qty }}</p>

          <template v-if="order.ingredients">
            <div
              v-if="
                order.ingredients['0'] &&
                order.ingredients['0'].sauces &&
                order.ingredients['0'].sauces.length > 0
              "
            >
              <p>
                Saucen:
                <span
                  v-for="(sauce, index) in order.ingredients['0'].sauces"
                  :key="index"
                >
                  <span class="mr-3">{{
                    sauce["name"] || sauce["label"]
                  }}</span>
                </span>
              </p>
            </div>

            <div
              v-if="
                order.ingredients['2'] &&
                order.ingredients['2'].meats &&
                order.ingredients['2'].meats.length > 0
              "
            >
              <p>
                Fleisch:
                <span
                  v-for="(meat, index) in order.ingredients['2'].meats"
                  :key="index"
                >
                  <span>{{ meat["name"] || meat["label"] }}</span>
                </span>
              </p>
            </div>

            <div
              v-if="
                order.ingredients['1'] &&
                order.ingredients['1'].salads &&
                order.ingredients['1'].salads.length > 0
              "
            >
              <p>
                Salate:
                <span
                  v-for="(salad, index) in order.ingredients['1'].salads"
                  :key="index"
                >
                  <span>{{ salad["name"] || salad["label"] }}</span>
                </span>
              </p>
            </div>

            <div
              v-if="
                order.ingredients['3'] &&
                order.ingredients['3'].extras &&
                order.ingredients['3'].extras.length > 0
              "
            >
              <p>
                Extras:
                <span
                  v-for="(extra, index) in order.ingredients['3'].extras"
                  :key="index"
                >
                  <span>{{ extra["name"] || extra["label"] }}</span>
                </span>
              </p>
            </div>

            <div
              v-if="order.ingredients['4'] && order.ingredients['4'].pommRice"
            >
              <p>
                Beilage:
                <span>
                  {{
                    order.ingredients["4"].pommRice["name"] ||
                    order.ingredients["4"].pommRice["label"]
                  }}
                </span>
              </p>
            </div>

            <div v-if="order.ingredients['5'] && order.ingredients['5'].drink">
              <p>
                Getränk:
                <span>
                  {{
                    order.ingredients["5"].drink["name"] ||
                    order.ingredients["5"].drink["label"]
                  }}
                </span>
              </p>
            </div>
          </template>

          <br />
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import jsPDF from "jspdf";
import moment from "moment";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      itemsPerPage: 10,
      isMounted: false,
      popupActive: false,
      selectedItem: null,
    };
  },
  computed: {
    paidAndSentOrders() {
      return this.$store.state.orders.ordersPaidAndSent || [];
    },
  },
  created() {
    this.getPaidAndSentOrders();
  },
  mounted() {
    this.isMounted = true;
  },
  methods: {
    ...mapActions({
      getPaidAndSentOrders: "orders/getPaidAndSentOrders",
    }),
    paymentIcon(method) {
      if (method === "paypal" || method === "paypal(app)")
        return "CreditCardIcon";
      if (method === "bar" || method === "bar(app)") return "DollarSignIcon";
      if (method && method.includes("stripe")) return "CreditCardIcon";
      return "CreditCardIcon";
    },
    paymentColor(method) {
      if (method === "paypal" || method === "paypal(app)") return "primary";
      if (method === "bar" || method === "bar(app)") return "warning";
      if (method && method.includes("stripe")) return "success";
      return "dark";
    },
    paymentBg(method) {
      if (method === "paypal" || method === "paypal(app)") return "#C41E2A";
      if (method === "bar" || method === "bar(app)") return "#FF9F43";
      if (method && method.includes("stripe")) return "#2ECC71";
      return "#666";
    },
    paymentLabel(method) {
      const labels = {
        paypal: "PayPal",
        "paypal(app)": "PayPal App",
        bar: "Bar",
        "bar(app)": "Bar App",
        "stripe(app)": "Stripe",
      };
      return labels[method] || method;
    },
    showDetails(item) {
      ((this.selectedItem = item), (this.popupActive = true));
    },
    print(order) {
      const pageWidth = 80;
      const margin = 4;
      const lineHeight = 4;
      let y = 6;

      // Collect all content first to calculate total height
      const lines = [];
      const addLine = (text, bold, size) => {
        lines.push({ text, bold: bold || false, size: size || 8 });
      };
      const addSep = () =>
        addLine("--------------------------------", false, 7);

      // Header
      addLine("PALACE OF KEBAP", true, 12);
      addLine(moment(order.paidAt).format("DD.MM.YYYY HH:mm"), false, 9);
      addSep();

      // Customer
      addLine(order.shippingAddress.name || "-", true, 9);
      addLine(
        (order.shippingAddress.street || "") +
          " " +
          (order.shippingAddress.streetNumber || ""),
      );
      addLine(
        (order.shippingAddress.zipCode || "") +
          " " +
          (order.shippingAddress.city || ""),
      );
      addLine("Tel: " + (order.shippingAddress.phone || "-"));
      if (order.shippingAddress.deliveryInstructions) {
        addLine("Hinweis: " + order.shippingAddress.deliveryInstructions);
      }
      addSep();

      // Order items
      for (let item of order.orderItems) {
        addLine(item.qty + "x " + item.name, true, 9);
        if (item.ingredients) {
          for (let sauce of (item.ingredients["0"] &&
            item.ingredients["0"].sauces) ||
            []) {
            addLine(
              "  " + this.replaceEuroSign(sauce["name"] || sauce["label"]),
            );
          }
          for (let meat of (item.ingredients["2"] &&
            item.ingredients["2"].meats) ||
            []) {
            addLine("  " + this.replaceEuroSign(meat["name"] || meat["label"]));
          }
          for (let salad of (item.ingredients["1"] &&
            item.ingredients["1"].salads) ||
            []) {
            addLine(
              "  " + this.replaceEuroSign(salad["name"] || salad["label"]),
            );
          }
          for (let extra of (item.ingredients["3"] &&
            item.ingredients["3"].extras) ||
            []) {
            addLine(
              "  + " + this.replaceEuroSign(extra["name"] || extra["label"]),
            );
          }
          if (item.ingredients["4"] && item.ingredients["4"].pommRice) {
            addLine(
              "  " +
                this.replaceEuroSign(
                  item.ingredients["4"].pommRice["name"] ||
                    item.ingredients["4"].pommRice["label"],
                ),
            );
          }
          if (item.ingredients["5"] && item.ingredients["5"].drink) {
            addLine(
              "  " +
                this.replaceEuroSign(
                  item.ingredients["5"].drink["name"] ||
                    item.ingredients["5"].drink["label"],
                ),
            );
          }
        }
      }
      addSep();

      // Total
      addLine("TOTAL: " + order.totalPrice.toFixed(2) + " EUR", true, 11);
      addLine(
        order.paymentMethod +
          (order.isPaid ? " (bezahlt)" : " (NICHT bezahlt)"),
        false,
        8,
      );
      addSep();
      addLine(order._id, false, 6);

      // Calculate total height
      let totalHeight = 6;
      for (let line of lines) {
        const fontSize = line.size || 8;
        totalHeight += fontSize < 10 ? lineHeight : lineHeight + 1;
      }
      totalHeight += 6;

      // Create PDF with calculated height
      let doc = new jsPDF({
        unit: "mm",
        format: [pageWidth, totalHeight],
      });

      // Render lines
      for (let line of lines) {
        const fontSize = line.size || 8;
        doc.setFontSize(fontSize);
        doc.setFont("helvetica", line.bold ? "bold" : "normal");
        doc.text(line.text || "", margin, y);
        y += fontSize < 10 ? lineHeight : lineHeight + 1;
      }

      doc.autoPrint();
      window.open(doc.output("bloburl"), "_blank");
    },
    replaceEuroSign(text) {
      if (typeof text == "string") {
        return text.replace("€", " EUR");
      } else {
        return "";
      }
    },
  },
};
</script>

<style>
.payment-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.3px;
}
</style>
